/**
 * The folder rail's React Query keys — ONE factory, and nothing else in here.
 *
 * It lives in a leaf module rather than beside the rail's hook so that code
 * which only needs to INVALIDATE the rail does not have to import the hook —
 * and with it `AuthContext`, and with that `lib/authRefresh`, which calls
 * `axios.create()` at module scope. `hooks/useComposerDraft` is the caller that
 * made this matter: it runs on the compose routes, has no business knowing
 * about auth plumbing, and its test suite mocks `axios` as a plain object with
 * no `create`, so the transitive import failed the whole suite at load.
 *
 * `hooks/useMailFolders` re-exports this, so every existing importer keeps
 * working and there is still exactly one definition of the keys. That single
 * definition is the point: an invalidation must never be able to drift from the
 * key the rail actually reads (#710).
 */

/**
 * Query keys, per lane.
 *
 * The personal lane and each unified inbox are separate cache entries on
 * purpose: they are separate authorisation scopes, and a shared key would show
 * one inbox's counts while another's request was in flight.
 */
export const mailFolderKeys = {
    all: ['mail', 'folders'],
    lane: inboxId => ['mail', 'folders', inboxId || 'personal'],
};

export default mailFolderKeys;
